// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56ba3309","250":"72e5ad65","453":"f7380716","455":"c6c046d8","968":"ebf3410e","977":"1da224d9"}[chunkId] + ".chunk.js";
};